import React from 'react'
import { Icon } from '@chakra-ui/icons'
import { Text } from '@chakra-ui/react'
import { FiSearch } from 'react-icons/fi'
import SharedStack from '~components/shared/wrappers/shared-stack'

interface Props {
    onClick: () => void
    labelOverride?: string
}

export default function ClientSearchTriggerButton({
    labelOverride,
    onClick,
}: Props) {
    return (
        <SharedStack
            row
            w="full"
            h="28px"
            px={2}
            cursor="text"
            borderRadius="full"
            fontSize="xs"
            fontWeight="normal"
            color="gray.500"
            bg="gray.100"
            overflow="hidden"
            onClick={onClick}
        >
            <Icon as={FiSearch} strokeWidth="2px" />
            <Text
                flex={1}
                whiteSpace="pre"
                overflow="hidden"
                textOverflow="ellipsis"
            >
                {labelOverride || 'Search clients and patients...'}
            </Text>
        </SharedStack>
    )
}
